import AuthTypeChoice from "./AuthTypeChoice";

const EntrarChoice = () => <AuthTypeChoice mode="login" />;

export default EntrarChoice;
